import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'ftr-confirmation-sent-page',
  template: '<ftr-confirmation-sent />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmationSentPage {}
